__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "nuskin-storefront";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (() => (__webpack_require__(17437))), 1);
			register("@emotion/styled", "11.14.1", () => (() => (__webpack_require__(83296))), 1);
			register("@nuskin/configuration-sdk", "2.2.3", () => (() => (__webpack_require__(14653))), 1);
			register("@nuskin/configuration-sdk", "3.0.2", () => (() => (__webpack_require__(84734))), 1);
			register("@nuskin/foundation-theme", "1.8.0", () => (() => (__webpack_require__(90410))), 1);
			register("@nuskin/foundation-ui-components", "2.2.1", () => (() => (__webpack_require__(34814))), 1);
			register("@nuskin/react-mysite-elements", "1.4.3", () => (() => (__webpack_require__(8140))), 1);
			register("mobx-react", "5.4.4", () => (() => (__webpack_require__(6359))), 1);
			register("mobx", "5.15.7", () => (() => (__webpack_require__(22451))), 1);
			register("pubsub-js", "1.9.4", () => (() => (__webpack_require__(50733))), 1);
			register("pubsub-js", "1.9.4", () => (() => (__webpack_require__(94575))), 1);
			register("pubsub-js", "1.9.5", () => (() => (__webpack_require__(23224))), 1);
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(40961))), 1);
			register("react", "18.2.0", () => (() => (__webpack_require__(96540))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};